// burada herhangibir yerde render olmayacağı için react'ı import etmeye gerek yok
import { useEffect, useState } from "react";
import firebase from "../firebase";
import moment from "moment";

export function useTodos() {
  const [todos, setTodos] = useState([]);

  useEffect(() => {
    console.log("effect called");
    //firebase bağlantı
    let unsubscribe = firebase
      .firestore()
      .collection("todos")
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        });
        console.log("subscribed");
        setTodos(data);
      });

    return () => {
      unsubscribe();
    };
  }, []);

  return todos;
}

// export function useProjects(todos) {
export function useProjects() {
  const [projects, setProjects] = useState([]);

  // yeri yanlış old. çıkardım, bunun için useProjectsWithStats olarak ayrı hook yapacağız
  // function calculateNumOfTodos(projectName, todos) {
  //   return todos.filter((todo) => todo.projectName === projectName).length;
  // }

  useEffect(() => {
    //firebase bağlantı
    let unsubscribe = firebase
      .firestore()
      .collection("projects")
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => {
          // const projectName = doc.data().name;
          return {
            id: doc.id,
            // name: projectName,
            name: doc.data().name,
            // burada artık gerek yok
            // numOfTodos: calculateNumOfTodos(projectName, todos),
          };
        });
        setProjects(data);
      });

    return () => {
      unsubscribe();
    };
  }, []);

  return projects;
}

export function useFilterTodos(todos, selectedProject) {
  //STATE
  const [filteredTodos, setFilteredTodos] = useState([]);

  useEffect(() => {
    let data;
    const todayDateFormated = moment().format("MM/DD/YYYY");

    // FILTER BOLUMU
    if (selectedProject === "today") {
      //today için filter
      data = todos.filter((todo) => todo.date === todayDateFormated);
    } else if (selectedProject === "next 7 days") {
      // next 7 days için filter
      data = todos.filter((todo) => {
        const todoDate = moment(todo.date, "MM/DD/YYYY");
        const todayDate = moment(todayDateFormated, "MM/DD/YYYY");
        const diffDays = todoDate.diff(todayDate, "days");
        return diffDays >= 0 && diffDays < 7;
      });
    } else if (selectedProject === "all days") {
      data = todos;
    } else {
      data = todos.filter((todo) => todo.projectName === selectedProject);
    }

    setFilteredTodos(data);
  }, [todos, selectedProject]);
  return filteredTodos;
}

export function useProjectsWithStats(projects, todos) {
  //STATE
  const [projectsWithStats, setProjectsWithStats] = useState([]);

  useEffect(() => {
    const data = projects.map((project) => {
      return {
        numOfTodos: todos.filter(
          (todo) => todo.projectName === project.name && !todo.checked
        ).length,
        ...project,
      };
    });
    setProjectsWithStats(data);
  }, [projects, todos]);

  return projectsWithStats;
}
